import React from 'react';
import {
  NotificationSettings,
  NotificationOptions,
  Container
} from 'components';

class NotificationSettingsContainer extends React.Component {
  render() {
    return (
      <div className='notification-settings-container'>
        <Container title='Notification Settings'>
          <NotificationSettings />
          <div style={{ marginTop: '80px' }} />
          <NotificationOptions />
        </Container>
      </div>
    );
  }
}

export default NotificationSettingsContainer;



// WEBPACK FOOTER //
// ./src/browser/components/settings/notifications/notification-settings-container.js